import httpClient from './_httpClient';

const getTemplatesByScopeAndType = (scopeId, type) => httpClient.get('/scopes/' + scopeId + '/sms-template/' + type);
const setSmsTemplate = (scopeId, templateId, text) => httpClient.put('/scopes/' + scopeId + '/sms-template/' + templateId, {text: text});
const estimateSms = (message, scopeId) => httpClient.post('/sms/estimate', {message, scopeId});
const testSmsTemplate = (scopeId, text, languageId) => httpClient.post('/scopes/' + scopeId + '/sms-template',
  {text: text,
   language_id: languageId});

export {
  getTemplatesByScopeAndType,
  setSmsTemplate,
  estimateSms,
  testSmsTemplate
}
